import { useMemo, useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { selectStoredSettings, setData } from 'cityads-v3/reducers/storedSettings'

export function useStoredSettings(key, defaultValue) {
  const dispatch = useDispatch();
  const selectValue = useMemo(() => selectStoredSettings(key, defaultValue), [defaultValue, key])
  const value = useSelector(selectValue);

  const setValue = useCallback(newValue => {
    dispatch(setData(convertDataToApi(newValue, key)));
  }, [dispatch, key]);

  return [value, setValue];
}

export function useLocalStorageReader(key) {
  const dispatch = useDispatch();

  useEffect(() => {
    try {
      const data = JSON.parse(window.localStorage.getItem(key));
      if (data !== null) {
        dispatch(setData(convertDataToApi(data, key)))
      }
    } catch (e) {}
  }, [dispatch, key]);
}

export function useStoredSettingsListener(key) {
  const value = useSelector(selectStoredSettings(key));

  useEffect(() => {
    if (value !== null && value !== undefined) {
      window.localStorage.setItem(key, JSON.stringify(value));
    }
  }, [key, value]);

}

function convertDataToApi(settings, key) {
  return {
    key,
    settings,
  }
}
